import Snackbar from "@mui/material/Snackbar";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { clearGuardianDenial, useGuardianDenial } from "../../common/guardian/denials";
import { GuardianDenialNotice } from "../../common/guardian/GuardianDenialNotice";

/**
 * App-wide answer to a guardian-control 403 (#2691). Any controlled action a
 * minor's guardians have not allowed — on any screen — lands here once, so
 * every entry point explains itself the same way and offers "Ask a guardian".
 * It is a non-blocking notice, not a dialog; it clears on navigation.
 */
export function GuardianPrompt() {
  const denial = useGuardianDenial();
  const { pathname } = useLocation();

  useEffect(() => {
    clearGuardianDenial();
  }, [pathname]);

  return (
    <Snackbar
      open={denial !== null}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ bottom: { xs: "calc(5.5rem + env(safe-area-inset-bottom, 0px))", sm: 24 } }}
    >
      <Box sx={{ width: "min(36rem, calc(100vw - 32px))" }}>
        {denial ? (
          // Keyed so a new denial starts its own Ask flow.
          <GuardianDenialNotice
            key={`${denial.code}:${denial.control}:${denial.subject?.id ?? ""}`}
            denial={denial}
            onClose={clearGuardianDenial}
          />
        ) : null}
      </Box>
    </Snackbar>
  );
}
